module.exports = __webpack_public_path__ + "static/media/cross-mobile-blue.4156b2d5.svg";